import { Stack } from "@mui/material";

function TodoPage() {
    function IsSleepyWorker() {
        return Math.floor(Math.random() * 10) >= 9;
    }
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}>
            {IsSleepyWorker() ?
                <img
                    width={500}
                    src={"https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/loaders/sleepyWorker.jpg"} /> :
                <img
                    width={500}
                    src={"https://ios-icc-components.s3.eu-west-1.amazonaws.com/report-app-components/loaders/workyWorker.webp"} />
            }

            <h1>Billing search temporary disabled. Please let Andrii and Oleg know if you need it</h1>
        </Stack>
    )
}

export default TodoPage;